<template>
  <div class="current-stats-container">
    <div class="w-full flex flex-row gap-4">
      <div class="flex flex-col">
        <label for="fromDate" class="text-sm font-semibold">From Date</label>
        <input
          type="date"
          name="fromDate"
          id="fromDate"
          v-model="date"
          @change="loadItems"
        />
      </div>
      <div class="flex flex-col">
        <label for="toDate" class="text-sm font-semibold">To Date</label>
        <input
          type="date"
          name="toDate"
          id="toDate"
          v-model="toDate"
          @change="loadItems"
        />
      </div>
      <a
        :href="
          `${url}/products/stats2?fromDate=${date}&toDate=${toDate}&token=${token}`
        "
        class="btn btn-export ml-auto"
        target="_blank"
      >
        export
      </a>
    </div>
    <div class="mt-4">
      <div v-if="loading">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div v-else-if="items.length == 0"></div>
      <div v-else>
        <table class="table">
          <thead>
            <tr>
              <th>Product</th>
              <th>Description</th>
              <th>Price</th>
              <th v-for="(marketplace, index) in marketplaces" :key="index">
                {{ marketplace }}
              </th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td>{{ item.productCode }}</td>
              <td>{{ item.description }}</td>
              <td>$ {{ item.price }}</td>
              <td v-for="(marketplace, index) in marketplaces" :key="index">
                {{ item[marketplace] }}
              </td>
              <td>{{ item.sum }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { getProductsStats } from "@/api/Products";

export default {
  name: "CurrentProductStats",
  data() {
    return {
      loading: true,
      marketplaces: [],
      items: [],
      // 1 year ago
      date: new Date(new Date().setDate(new Date().getDate() - 365))
        .toISOString()
        .split("T")[0],
      // today
      toDate: new Date().toISOString().split("T")[0],
      publicPath: process.env.VUE_APP_IMG_BASE_URL
    };
  },
  computed: {
    url() {
      return process.env.VUE_APP_NKRSYNC_BE;
    },
    token() {
      return this.$store.getters["auth/currentToken"];
    }
  },
  methods: {
    loadItems() {
      this.loading = true;
      getProductsStats(this.date, this.toDate)
        .then(response => {
          this.items = response.products;
          this.marketplaces = response.marketplaces;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.loadItems();
  }
};
</script>

<style scoped>
.current-stats-container {
  width: 100%;
}

.btn-export {
  padding: 0.5rem 1rem;
  background-color: #333;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  text-decoration: none;
  display: inline-block;
  align-self: flex-end;
  transition: background-color 0.3s ease;
}

.btn-export:hover {
  background-color: #555;
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
  border: 1px solid #dee2e6;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  background-color: #f8f9fa;
}

.table tbody + tbody {
  border-top: 2px solid #dee2e6;
}

.table .table {
  background-color: #fff;
}
</style>
